import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { PARAM_TAGS_PATH } from "src/app/admin/constants/constants";

import { AbstractListController } from "src/app/admin/common/abstract-list.component";
import { TagsService } from "src/app/services/tags.service";
import { Tags } from "src/app/models/tags";
import { CommonModule } from "@angular/common";
import { DataTableComponent } from "src/app/admin/common/data-table/data-table.component";
import {
  TableColumn,
  TableFilter,
} from "src/app/admin/common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-tags",
  templateUrl: "./manage-tags.component.html",
  imports: [CommonModule, DataTableComponent],
})
export class ManageTagsComponent extends AbstractListController<Tags, any> {
  title = "Tags";

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    { field: "title", header: "Nome" },
    { field: "description", header: "Descrizione" },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "title", header: "Nome", type: "string" },
    { field: "description", header: "Descrizione", type: "string" },
  ];

  editLink = (row: Tags): any[] => ["/admin/settings/tags/edit", row.id];

  constructor(
    private tagsService: TagsService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(tagsService, confirmationService, router, route, PARAM_TAGS_PATH);
    this.useTableFilters = true;
  }
}
